module.exports = __webpack_public_path__ + "img/phone-icon-us.bb93ec15.svg";